import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { PHONE_VERIFY_STATUS } from '@/auth/values/auth.values';
import KEYS from '@/values/keys';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';

@Component({
  name: 'ed-register-validate-phone'
})
export default class EdRegisterValidatePhoneComponent extends Vue {

  /* Props */
  @Prop() readonly params: any;

  /* Data */
  public validating: boolean = false;
  public code: number = null;
  public attempts: number = 0;
  public verificationId: number = 0;
  public verificationStatus: string = '';

  /* Computed */
  get codeInvalid () { 
    return !this.code || this.code?.toString().length < 6 || PHONE_VERIFY_STATUS.MAX_ATTEMPTS_EXCEEDED.status == this.verificationStatus;
  }

  get modalTitle() {
    return this.params.title || this.$t('auth.register.register');
  }

  get showResendCode() {
    return PHONE_VERIFY_STATUS.MAX_ATTEMPTS_EXCEEDED.status != this.verificationStatus
  }
 
  /* Methods */
  public closeModal() {
    this.$EdModal.closeModal();
  }

  public async validate () {
    this.validating = true;
    try {
      let response = await this.$Auth.Services.validatePhoneCode(this.code, this.verificationId);
      this.validating = false;
    
      if(PHONE_VERIFY_STATUS.VALIDATED.status == response.status) {
        this.params.getVerificationResponse(response.id, this.code);
        this.closeModal();
      }

      this.verificationStatus = response.status

      this.$EdToast.create({ 
        msg: `${this.$t(PHONE_VERIFY_STATUS[response.status].code)}`,
        type: PHONE_VERIFY_STATUS[response.status].type,
        top: '5.5rem',
        timeout: 3000
      }); 

      this.attempts = response.attempts

    } catch {
      this.validating = false;
      this.$EdToast.create({ 
        msg: `${this.$t('auth.register.errors.phoneNoVerified')}`,
        type: TOAST_TYPES.DANGER,
        top: '5.5rem',
        timeout: 3000
      });
      this.closeModal();
    }
  }

  async sendCodeAgain () {
    try {
      await this.$Auth.Services.resendPhoneCode(this.verificationId);
    } catch {
      this.$EdModal.createMessageModal({
        title: this.$i18n.t('auth.register.register'),
        body: this.$i18n.t('auth.register.errors.codeNotSent'),
        type: KEYS.EVENT_TYPES.WARNING
      });
    }
  }
  
  getCode(code) {
    this.code = Number(code)
  }

  created() {
    this.verificationId = this.params.verificationId
  }
}